import ApiClientFactory from '@/api/apiClientFactory';
import Vue from 'vue';

import {
  OrderAction,
  OrderGetter,
  OrderModule,
  OrderMutation,
  OrderState
} from './order.module-types';

export const orderModule: OrderModule = {
  namespaced: true,
  state: {
    [OrderState.order]: null,
    [OrderState.orderMaterial]: null,
    [OrderState.companyInvoiceInfo]: {
      companyName: 'Công Ty TNHH MTV THẾ GIỚI STICKER',
      companyAddress: '119/45 Nguyễn Hồng Đào, Phường Tân Bình, TP.HCM, VN',
      companyPhone: '090 139 1815 - 091 346 1539.'
    }
  },
  mutations: {
    [OrderMutation.setOrder]: (state, payload) => {
      state[OrderState.order] = payload;
    },
    [OrderMutation.setOrderMaterial]: (state, payload) => {
      state[OrderState.orderMaterial] = payload;
    },
    [OrderMutation.setCompanyInvoiceInfo]: (state, payload) => {
      state[OrderState.companyInvoiceInfo] = {
        companyAddress: payload?.companyAddress ?? '',
        companyPhone: payload?.companyPhone ?? '',
        companyName: payload?.companyName ?? ''
      };
    },
    [OrderMutation.resetCompanyInvoiceInfo]: (state) => {
      state[OrderState.companyInvoiceInfo] = {
        companyName: 'Công Ty TNHH MTV THẾ GIỚI STICKER',
        companyAddress: '119/45 Nguyễn Hồng Đào, Phường Tân Bình, TP.HCM, VN',
        companyPhone: '090 139 1815 - 091 346 1539.'
      };
    }
  },
  actions: {
    [OrderAction.loadOrder]: async ({ commit }, id: number) => {
      commit(
        OrderMutation.setOrder,
        await new ApiClientFactory().orderClient().get(id)
      );
    },
    [OrderAction.clearOrder]: ({ commit }) => {
      commit(OrderMutation.setOrder, null);
    },
    [OrderAction.getOrderMaterial]: async ({ commit }, productId) => {
      const clientApi = new ApiClientFactory();
      const result = await clientApi
        .orderClient()
        .getOrderMaterialByProductId(productId);

      commit(OrderMutation.setOrderMaterial, result);
    }
  },
  getters: {
    [OrderGetter.order]: (state) => state[OrderState.order],
    [OrderGetter.companyInvoiceInfo]: (state) =>
      state[OrderState.companyInvoiceInfo]
  }
};
